var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');

var addDiagramModal = {};

addDiagramModal.name = prop('');
addDiagramModal.error = prop('');

addDiagramModal.open = function (parentLocation, options) {
  addDiagramModal.name('');
  addDiagramModal.error('');

  var submit = function () {
    var name = String(addDiagramModal.name() || '').trim();
    if (!name) {
      addDiagramModal.error('Name is required.');
      m.redraw();
      return;
    }

    return loaders.requestWithLoader({
      loader: 'main',
      url: '/api/v1/diagram',
      method: 'POST',
      body: {
        name: name,
        parentLocation: parentLocation && parentLocation['@rid']
      }
    })
    .then(function (diagram) {
      key.unbind('enter');
      modal.vm.close();
      if (options && typeof options.submitCallback === 'function') {
        options.submitCallback();
      }
      if (diagram && diagram['@rid']) {
        m.route.set('/diagram/' + diagram['@rid'].slice(1));
      }
    })
    .catch(function (error) {
      addDiagramModal.error(error && (error.message || error.error) || 'Unable to create diagram.');
      m.redraw();
    });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);
  modal.vm.title('Add Diagram');
  modal.vm.body = addDiagramModal.view;
  modal.vm.buttons([
    {
      label: 'Save',
      class: 'btn-good',
      func: submit
    }
  ]);
  modal.vm.open();
};

addDiagramModal.view = function () {
  return m('form', { role: 'form' }, [
    addDiagramModal.error() ? m('div.red.mb2', addDiagramModal.error()) : '',
    m('div.form-group', [
      m('label', 'Name'),
      m('input.form-control', {
        value: addDiagramModal.name(),
        oninput: function (e) {
          addDiagramModal.name(e.target.value);
        }
      })
    ])
  ]);
};

module.exports = addDiagramModal;
